import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';
import { BrandGateway } from '@domain/models/brand/gateway/brand.gateway';
import { BrandResources } from '@domain/models/brand/brand-resources.model';
import { AlertService } from '../alert-service/alert.service';
import { HttpClient, HttpContext } from '@angular/common/http';
import { AlertPosition, AlertType } from '@domain/enums/alert/alert-type.enum';
import { environment } from '@environments/environment';
import { IS_PUBLIC } from '@infraestructure/helpers/auth/auth.interceptor';
import { Brand } from '@domain/enums/brand/brand.enum';

@Injectable({
  providedIn: 'root',
})
export class BrandService extends BrandGateway {
  private _brandResources: BehaviorSubject<BrandResources> = new BehaviorSubject<BrandResources>(this.getStoredBrandResources());
  private _brandTitle: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(this.getStoredBrandTitle());
  private _brand!: string;

  constructor(
    private _alertService: AlertService,
    private _http: HttpClient
  ) {
    super();
  }

  private getStoredBrandResources(): BrandResources {
    const storedData = localStorage.getItem('brandResources');
    return storedData ? JSON.parse(storedData) : undefined!;
  }

  private storeBrandResources(brandResources: BrandResources): void {
    localStorage.setItem('brandResources', JSON.stringify(brandResources));
    this._brandResources.next(brandResources);
    this._brand = Brand[brandResources?.brandResource?.brand!];
    this._brandTitle.next(brandResources?.brandResource?.brandTitle!);
  }

  getBrandResources(brand: string): Observable<BrandResources> {
    if(brand == this._brand) {
      return this._brandResources.asObservable();
    }
    return this._http.get<BrandResources>(`${environment.memberPortalServiceURL.replace('{{brandDomain}}', window.location.host)}/settings/brandresources?brand=${brand}`, {
      context: new HttpContext().set(IS_PUBLIC, true),
    })
    .pipe(
      map((brandResourcesResponse: BrandResources) => {
        this.storeBrandResources(brandResourcesResponse!);
        return brandResourcesResponse;
      }),
      catchError((e) => {
        console.log(e);
        this._alertService.showAlert({
          type: AlertType.Error,
          title: 'Error',
          description: e?.error?.Message,
          position: AlertPosition.TopCenter,
        });
        return of();
      })
    );
  }

  public getSelectedBrandResources(): Observable<BrandResources> {
    return this._brandResources.asObservable();
  }

  private getStoredBrandTitle(): string | null {
    const resources = this.getStoredBrandResources();
    return resources?.brandResource?.brandTitle ?? "PFI Verify";
  }

  public getBrandTitle(): Observable<string | null> {
    return this._brandTitle.asObservable();
  }
}
